module.exports = __webpack_public_path__ + "img/SK50875621.2607b872.png";